{
    "defaultErrorMessage": "Something went wrong.",
    "errorCode": "error",
    "successCode": "success",
    "report": "Report / ",
    "attendance": "Attendance",
    "export": "Export",
    "filter": "Filter by :",
    "wing": "Wing :",
    "class": "Class :",
    "section": "Section : ",
    "date": "Date :",
    "gender": "Gender :",
    "selectedStudent": "Selected student :",
    "reset": "Reset",
    "exportFirstMessage": "You will export this report, and it will be sent to all super admins.",
    "exportSecondMessage": "If you wish to send the report to a different email, please enter the email address.",
    "exportReport": "Export report",
    "moreFilter": "More filter",
    "lessFilter": "Less filter",
    "selectWing": "Select wing",
    "selectClass": "Select class",
    "selectSection": "Select section",
    "selectDate": "Select date",
    "selectGender": "Select gender",
    "selectStudent": "Select student",
    "resultAvailable": "results available.",
    "applyFilter": "Apply filter",
    "attendanceMarked": "Attendance marked",
    "attendanceNotMarked": "Attendance not marked",
    "presentStudent": "Present",
    "absentStudent": "Absent",
    "showResult": "Show result ",
    "all": "All",
    "dataNotAvailable": "Data not available",
    "dataNotAvailableSecond": "Sorry, we couldn’t find any data for the applied filter.",
    "reportFormat":"Excel",
    "searchStuduentPlaceholder": "Search student's",
    "selectedStudentText":" student(s) selected",
    "searchStudentLabel": "Search student"
}